import {
  CALENDAR_ITEM_KIND_TAG_PROPS,
  CALENDAR_ITEM_STATUS_PROPS,
  CalendarItemStatusName,
} from '../../Calendar.constants'

export function getCalendarItemCardTags({ isArchived, isDue, kind }) {
  return [
    CALENDAR_ITEM_KIND_TAG_PROPS[kind],
    isDue ? CALENDAR_ITEM_STATUS_PROPS[CalendarItemStatusName.due] : null,
    isArchived
      ? CALENDAR_ITEM_STATUS_PROPS[CalendarItemStatusName.archived]
      : null,
  ].filter(Boolean)
}
